import { authHeader, handleResponse } from "../helper/auth-header";

export default class AccessRightService {
  ControllerName = "Login";

  // get menu according user
  async GetAccessRight(userId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetAccessRight/${userId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
  // get create and update access right
  async CreateUpdateAccessRight(accessdata) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(accessdata)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateAccessRight`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async getUserMenu(userId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetUserMenu?userId=${userId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetUsers(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetUsers`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async GetUsersDDL() {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetUsersDDL`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  async CreateUpdateUser(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };

    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateUser`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
